module.exports = __webpack_public_path__ + "static/media/adult-amplifier-band-375893.83154271.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/static/adult-amplifier-band-375893.jpg
// module id = 283
// module chunks = 0